import React from 'react';

import classNames from 'classnames';

import { ORG_ROLE_ADMIN, orgRoleLabel, STATUS_ACTIVE, STATUS_DEACTIVATED, STATUS_INVITE_EXPIRED } from './organisationUserFormat';

// Badge's colours without its leading dot: the design's pills are text only.
const PILL = 'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-md tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium';

const STATUS_PILLS = {
    [STATUS_ACTIVE]: { className: 'tw-bg-green-25 tw-text-green-600', label: () => $t('Active') },
    [STATUS_INVITE_EXPIRED]: { className: 'tw-bg-red-25 tw-text-red-600', label: () => $t('Invite expired') },
    [STATUS_DEACTIVATED]: { className: 'tw-bg-charcoal-15 tw-text-charcoal-75', label: () => $t('Deactivated') },
    invited: { className: 'tw-bg-amber-100 tw-text-amber-700', label: () => $t('Invited') },
};

export function StatusPill({ status, invitedLabel }) {
    const pill = STATUS_PILLS[status] || STATUS_PILLS.invited;
    const label = pill === STATUS_PILLS.invited && invitedLabel ? invitedLabel : pill.label();

    return <span className={classNames(PILL, pill.className)}>{label}</span>;
}

export function MfaPill({ setUp }) {
    return (
        <span className={classNames(PILL, setUp ? 'tw-bg-green-25 tw-text-green-600' : 'tw-bg-amber-100 tw-text-amber-700')}>
            {setUp ? $t('Set up') : $t('Not set up')}
        </span>
    );
}

export function OrgRolePill({ orgRole }) {
    return (
        <span className={classNames(PILL, orgRole === ORG_ROLE_ADMIN ? 'tw-bg-blue-15 tw-text-blue' : 'tw-bg-charcoal-15 tw-text-charcoal-75')}>
            {orgRoleLabel(orgRole)}
        </span>
    );
}

export function CountBadge({ value }) {
    return (
        <span className="tw-inline-flex tw-min-w-[1.5rem] tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-15 tw-px-1.5 tw-py-0.5 tw-text-xs tw-font-medium tw-text-blue">
            {value}
        </span>
    );
}
